// extracted by mini-css-extract-plugin
module.exports = {"root":"Invoice_root__1TzmJ","invoiceLogo":"Invoice_invoiceLogo__2GZhv","invoiceBody":"Invoice_invoiceBody__ve4pg"};